var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCameraSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 24H4C3.46957 24 2.96086 23.7793 2.58579 23.3863C2.21071 22.9934 2 22.4605 2 21.9048V7.2381C2 6.6824 2.21071 6.14947 2.58579 5.75654C2.96086 5.36361 3.46957 5.14286 4 5.14286H8L10 2H18L20 5.14286H24C24.5304 5.14286 25.0391 5.36361 25.4142 5.75654C25.7893 6.14947 26 6.6824 26 7.2381V21.9048C26 22.4605 25.7893 22.9934 25.4142 23.3863C25.0391 23.7793 24.5304 24 24 24Z",
    stroke: "#E5E5E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19C16.4853 19 18.5 16.7614 18.5 14C18.5 11.2386 16.4853 9 14 9C11.5147 9 9.5 11.2386 9.5 14C9.5 16.7614 11.5147 19 14 19Z",
    stroke: "#E5E5E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 26,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraSwitch);
export default __webpack_public_path__ + "static/media/icon-camera-switch.3bd09523c159feebc1d1c3c0c15213b2.svg";
export { ForwardRef as ReactComponent };